interface IConfigScheme {
	URL_API: string;
	URL_FORM: string;
	name: string;
}

export const live: IConfigScheme = {
	URL_API: "https://cabinet.impaya.com/api/v2/",
	URL_FORM: "https://cabinet.impaya.com",
	name: "live",
};

export const local: IConfigScheme = {
	URL_API: "http://localhost:8096/api/v2/",
	URL_FORM: "http://localhost:3000",
	name: "local",
};

class Config {
	static storageVersion: number = 1;
	static scheme: IConfigScheme = live;
	// sourced from package.json at build time (see vite.config.ts `define`)
	static version: string = __APP_VERSION__;
}

export default Config;
